// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 100px 0 80px;
`;
export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 40px;
`;
export const DeleteIconContainer = styled.img`
  width: 40px;
  height: 40px;
  cursor: pointer;
`;
export const EditIconContainer = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 20px;
  cursor: pointer;
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 60px 40px;
  width: 1560px;
  height: 560px;
  background: ${COLORS.primaryWhite};
  border-radius: 10px;
`;
export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 35px;
`;
export const TitleContainer = styled.text`
  font-size: 30px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.cornflowerBlue};
  margin-bottom: 20px;
`;
export const TextContainer = styled.text`
  font-size: 18px;
  font-weight: 500;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryBlack};
  height: 330px;
  margin-bottom: 20px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.thirdGray};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;
export const DateContainer = styled.text`
  font-size: 20px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.primaryGray};
`;
export const PhotosContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const BigPhotoContainer = styled.div`
  margin-bottom: 20px;
`;
export const SmallPhotosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const PhotoContainer = styled.img(
  ({ width, height }) => css`
    width: ${width ? width : "190px"};
    height: ${height ? height : "142px"};
    border-radius: 15px;
  `
);
